import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
  Box,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import usePhotosDialogStyles from "./css/usePhotosDialogStyles";

interface CommentDialogProps {
  open: boolean;
  hasComment: boolean;
  comment: string;
  onClose: () => void;
  onSave: () => void;
  onChange: (val: string) => void;
  inputRef: React.RefObject<HTMLTextAreaElement | HTMLInputElement | null>;
  t: (key: string, fallback?: string) => string;
}

const CommentDialog: React.FC<CommentDialogProps> = ({
  open,
  hasComment,
  comment,
  onClose,
  onSave,
  onChange,
  inputRef,
  t,
}) => {
  const { classes } = usePhotosDialogStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      scroll="body"
      PaperProps={{ style: { maxHeight: "none", overflow: "visible" } }}
      TransitionProps={{
        onEntered: () => {
          const el = inputRef.current;
          if (el) {
            const len = el.value.length;
            el.focus();
            if (hasComment) {
              // redaguojant – kursorius gale
              el.setSelectionRange(len, len);
            } else {
              // pridedant – kursorius pradžioje
              el.setSelectionRange(0, 0);
            }
          }
        },
      }}
    >
      <DialogTitle className={classes.commentDialogTitle}>
        {hasComment
          ? t("editComment", "Redaguoti komentarą")
          : t("commentAdd", "Įrašykite komentarą")}
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.commentDialogContent}>
        <Box className={classes.commentBox}>
          <TextField
            multiline
            rows={3}
            fullWidth
            inputRef={inputRef}
            value={comment}
            onChange={(e) => onChange(e.target.value)}
            placeholder={t("enterText", "Įrašykite tekstą...")}
            inputProps={{ maxLength: 100 }}
            helperText={
              <Typography
                variant="caption"
                sx={{ display: "block", textAlign: "right", width: "100%" }}
              >
                {100 - comment.length}/100
              </Typography>
            }
            className={classes.commentTextField}
          />
        </Box>
      </DialogContent>

      <DialogActions className={classes.commentDialogActions}>
        <Button color="inherit" onClick={onClose}>
          {t("cancelDialog", "Atšaukti")}
        </Button>
        <Button onClick={onSave}>
          {hasComment
            ? t("saveComment", "Išsaugoti komentarą")
            : t("addcomment", "Pridėti komentarą")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommentDialog;
